const navbar = {
  packages: "Pakete", // translated
  experiences: "Erfahrungen", // translated
  close: "Schließen", // translated
  hotDeals: "Heiße Angebote", // translated
  dashboard: "Armaturenbrett", // translated
  hotelPackages: "Hotelpakete", // translated
  pricing: "Preisgestaltung", // translated
};

export default navbar;
